import * as DialogPrimitive from "@radix-ui/react-dialog";
import { Xmark } from "iconoir-react";
import { Icon } from "@/design-system/icons/icon";
import { cn } from "@/lib/cn";

export const Drawer = DialogPrimitive.Root;
export const DrawerTrigger = DialogPrimitive.Trigger;
export const DrawerClose = DialogPrimitive.Close;
export const DrawerTitle = DialogPrimitive.Title;
export const DrawerDescription = DialogPrimitive.Description;
export function DrawerContent({
  children,
  className,
}: React.ComponentPropsWithoutRef<typeof DialogPrimitive.Content>) {
  return (
    <DialogPrimitive.Portal>
      <DialogPrimitive.Overlay className="fixed inset-0 z-40 bg-[var(--color-status-backdrop)]" />
      <DialogPrimitive.Content
        className={cn(
          "fixed inset-y-0 right-0 z-50 flex w-full flex-col overflow-hidden border-l border-line bg-elevated sm:w-[min(var(--control-drawer-width),100vw)]",
          className,
        )}
      >
        {children}
      </DialogPrimitive.Content>
    </DialogPrimitive.Portal>
  );
}
export function DrawerHeader({
  children,
  className,
  closeLabel,
  ...props
}: React.HTMLAttributes<HTMLDivElement> & { closeLabel: string }) {
  return (
    <div
      className={cn(
        "grid min-h-[var(--layout-header)] grid-cols-[minmax(0,1fr)_auto] items-start gap-4 border-b border-line px-6 py-5 sm:px-8 sm:py-6",
        className,
      )}
      {...props}
    >
      <div className="min-w-0">{children}</div>
      <DialogPrimitive.Close
        aria-label={closeLabel}
        className="grid size-11 place-items-center rounded-full hover:bg-hover"
      >
        <Icon glyph={Xmark} />
      </DialogPrimitive.Close>
    </div>
  );
}
export function DrawerBody({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        "min-h-0 flex-1 overflow-y-auto px-6 py-6 sm:px-8",
        className,
      )}
      {...props}
    />
  );
}
export function DrawerFooter({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        "relative z-10 mt-auto flex min-h-[calc(var(--layout-header)+0.5rem)] shrink-0 flex-col-reverse gap-3 border-t border-line bg-elevated px-6 py-4 [&>button]:w-full sm:min-h-[var(--layout-header)] sm:flex-row sm:items-center sm:justify-end sm:px-8 sm:[&>button]:w-auto",
        className,
      )}
      {...props}
    />
  );
}
